import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TalkingAboutYourFamilyRedirect: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the proper pathway URL
    navigate('/pathways/talking-about-your-family', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to Talking About Your Family...</p>
      </div>
    </div>
  );
};

export default TalkingAboutYourFamilyRedirect;
